const moduleMap = {
	"./config": () => {
		return Promise.all([__webpack_require__.e(79), __webpack_require__.e(914), __webpack_require__.e(399), __webpack_require__.e(968), __webpack_require__.e(95), __webpack_require__.e(96), __webpack_require__.e(137), __webpack_require__.e(381), __webpack_require__.e(220)]).then(() => (() => ((__webpack_require__(1220)))));
	},
	"./register": () => {
		return Promise.all([__webpack_require__.e(137), __webpack_require__.e(479)]).then(() => (() => ((__webpack_require__(7479)))));
	},
	"./components": () => {
		return Promise.all([__webpack_require__.e(79), __webpack_require__.e(914), __webpack_require__.e(75), __webpack_require__.e(968), __webpack_require__.e(95), __webpack_require__.e(335), __webpack_require__.e(678)]).then(() => (() => ((__webpack_require__(7678)))));
	},
	"./constants": () => {
		return __webpack_require__.e(265).then(() => (() => ((__webpack_require__(1646)))));
	},
	"./hooks": () => {
		return Promise.all([__webpack_require__.e(79), __webpack_require__.e(914), __webpack_require__.e(399), __webpack_require__.e(968), __webpack_require__.e(96), __webpack_require__.e(120)]).then(() => (() => ((__webpack_require__(4120)))));
	},
	"./sagas": () => {
		return Promise.all([__webpack_require__.e(79), __webpack_require__.e(399), __webpack_require__.e(638)]).then(() => (() => ((__webpack_require__(5638)))));
	},
	"./styles": () => {
		return __webpack_require__.e(769).then(() => (() => ((__webpack_require__(9769)))));
	},
	"./types": () => {
		return __webpack_require__.e(774).then(() => (() => ((__webpack_require__(2774)))));
	},
	"./utils": () => {
		return Promise.all([__webpack_require__.e(79), __webpack_require__.e(2)]).then(() => (() => ((__webpack_require__(1002)))));
	},
	"./authorize": () => {
		return __webpack_require__.e(586).then(() => (() => ((__webpack_require__(8586)))));
	}
};
const get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
const init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	const name = "default"
	const oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});